import { CDN_URL } from "../Server";

export const DashboardIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 4.19995C1 3.07995 1 2.52009 1.218 2.09009C1.41 1.72009 1.716 1.40997 2.092 1.21997C2.52 0.999971 3.08 1 4.2 1H4.8C5.92 1 6.48 0.999971 6.908 1.21997C7.284 1.40997 7.59 1.72009 7.782 2.09009C8 2.52009 8 3.07995 8 4.19995V4.80005C8 5.92005 8 6.47991 7.782 6.90991C7.59 7.27991 7.284 7.59003 6.908 7.78003C6.48 8.00003 5.92 8 4.8 8H4.2C3.08 8 2.52 8.00003 2.092 7.78003C1.716 7.59003 1.41 7.27991 1.218 6.90991C1 6.47991 1 5.92005 1 4.80005V4.19995ZM1 15.2C1 14.08 1 13.5201 1.218 13.0901C1.41 12.7201 1.716 12.41 2.092 12.22C2.52 12 3.08 12 4.2 12H4.8C5.92 12 6.48 12 6.908 12.22C7.284 12.41 7.59 12.7201 7.782 13.0901C8 13.5201 8 14.08 8 15.2V15.8C8 16.92 8 17.4799 7.782 17.9099C7.59 18.2799 7.284 18.59 6.908 18.78C6.48 19 5.92 19 4.8 19H4.2C3.08 19 2.52 19 2.092 18.78C1.716 18.59 1.41 18.2799 1.218 17.9099C1 17.4799 1 16.92 1 15.8V15.2ZM12 4.19995C12 3.07995 12 2.52009 12.218 2.09009C12.41 1.72009 12.716 1.40997 13.092 1.21997C13.52 0.999971 14.08 1 15.2 1H15.8C16.92 1 17.48 0.999971 17.908 1.21997C18.284 1.40997 18.59 1.72009 18.782 2.09009C19 2.52009 19 3.07995 19 4.19995V4.80005C19 5.92005 19 6.47991 18.782 6.90991C18.59 7.27991 18.284 7.59003 17.908 7.78003C17.48 8.00003 16.92 8 15.8 8H15.2C14.08 8 13.52 8.00003 13.092 7.78003C12.716 7.59003 12.41 7.27991 12.218 6.90991C12 6.47991 12 5.92005 12 4.80005V4.19995ZM12 15.2C12 14.08 12 13.5201 12.218 13.0901C12.41 12.7201 12.716 12.41 13.092 12.22C13.52 12 14.08 12 15.2 12H15.8C16.92 12 17.48 12 17.908 12.22C18.284 12.41 18.59 12.7201 18.782 13.0901C19 13.5201 19 14.08 19 15.2V15.8C19 16.92 19 17.4799 18.782 17.9099C18.59 18.2799 18.284 18.59 17.908 18.78C17.48 19 16.92 19 15.8 19H15.2C14.08 19 13.52 19 13.092 18.78C12.716 18.59 12.41 18.2799 12.218 17.9099C12 17.4799 12 16.92 12 15.8V15.2Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const SignOutIcon = () => {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.21403 22.0009C2.89385 22.0055 2.57614 21.9444 2.28049 21.8214C1.98484 21.6984 1.71752 21.5162 1.49502 21.2859C1.2647 21.0635 1.08243 20.7961 0.959456 20.5005C0.83648 20.2048 0.775415 19.8871 0.780028 19.5669V14.6979H3.21403V19.5669H20.255V2.52593H3.21403V7.39495H0.780028V2.52593C0.775534 2.20576 0.836655 1.8881 0.959624 1.59246C1.08259 1.29681 1.2648 1.02947 1.49502 0.806933C1.71756 0.576708 1.98489 0.394501 2.28053 0.271532C2.57617 0.148563 2.89386 0.0874112 3.21403 0.0919057H20.255C20.5752 0.0874112 20.8929 0.148563 21.1885 0.271532C21.4842 0.394501 21.7515 0.576708 21.974 0.806933C22.2043 1.02947 22.3865 1.29681 22.5094 1.59246C22.6324 1.8881 22.6935 2.20576 22.689 2.52593V19.5669C22.6936 19.8871 22.6326 20.2048 22.5096 20.5005C22.3866 20.7961 22.2043 21.0635 21.974 21.2859C21.7515 21.5162 21.4842 21.6984 21.1886 21.8214C20.8929 21.9444 20.5752 22.0055 20.255 22.0009H3.21403ZM9.90903 17.1319L8.20903 15.3669L11.309 12.267H0.780028V9.83196H11.309L8.20903 6.73192L9.90903 4.96691L15.995 11.0529L9.90903 17.1319Z"
        fill="#333333"
      />
    </svg>
  );
};
export const ScanQRIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      stroke="#000000"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="2" y="2" width="8" height="8" />
      <path d="M6 6h.01" />
      <rect x="14" y="2" width="8" height="8" />
      <path d="M18 6h.01" />
      <rect x="2" y="14" width="8" height="8" />
      <path d="M6 18h.01" />
      <path d="M14 14h.01" />
      <path d="M18 18h.01" />
      <path d="M18 22h4v-4" />
      <path d="M14 18v4" />
      <path d="M22 14h-4" />
    </svg>
  );
};
export const TeamDashboardIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 14.2917V19.0889C1 20.4578 1 21.1421 1.2628 21.6677C1.49425 22.1199 1.86312 22.4989 2.31638 22.7311C2.83232 23 3.50739 23 4.85753 23H9.13699M1 14.2917V4.91105C1 3.54216 1 2.85789 1.2628 2.33233C1.49425 1.88011 1.86312 1.50108 2.31638 1.26885C2.83232 0.999964 3.50739 1 4.85753 1H19.1425C20.4926 1 21.1677 0.999964 21.6836 1.26885C22.1369 1.50108 22.5058 1.88011 22.7372 2.33233C23 2.85789 23 3.54216 23 4.91105V14.2917M1 14.2917H9.13699M23 14.2917V19.0889C23 20.4578 23 21.1421 22.7372 21.6677C22.5058 22.1199 22.1369 22.4989 21.6836 22.7311C21.1677 23 20.4926 23 19.1425 23H9.13699M23 14.2917H9.13699M9.13699 14.2917V23"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
  );
};
export const WorkflowIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 5.02002C6 4.09002 6.00001 3.60997 6.10201 3.21997C6.23976 2.71206 6.50813 2.24914 6.88043 1.8772C7.25273 1.50525 7.71596 1.23737 8.224 1.1001C8.605 1.0001 9.07 1 10 1C10.93 1 11.395 1.0001 11.776 1.1001C12.284 1.23737 12.7473 1.50525 13.1196 1.8772C13.4919 2.24914 13.7602 2.71206 13.898 3.21997C14 3.60997 14 4.09002 14 5.02002M10 13V15M1.023 9.95996C1.13687 11.0681 1.65768 12.0945 2.48468 12.8408C3.31168 13.5871 4.38607 14.0001 5.5 14H14.5C15.6139 14.0001 16.6883 13.5871 17.5153 12.8408C18.3423 12.0945 18.8631 11.0681 18.977 9.95996M1.023 9.95996C1 10.49 1 11.15 1 12C1 13.86 1 14.79 1.245 15.55C1.48992 16.2998 1.90823 16.9813 2.46599 17.5391C3.02374 18.0968 3.7052 18.5151 4.455 18.76C5.208 19 6.139 19 8 19H12C13.861 19 14.792 19 15.545 18.76C16.2948 18.5151 16.9763 18.0968 17.534 17.5391C18.0918 16.9813 18.5101 16.2998 18.755 15.55C19 14.79 19 13.86 19 12C19 11.15 19 10.49 18.977 9.95996M1.023 9.95996C1.051 9.32996 1.112 8.85995 1.245 8.44995C1.48992 7.70015 1.90823 7.01869 2.46599 6.46094C3.02374 5.90318 3.7052 5.4849 4.455 5.23999C5.208 4.99999 6.139 5 8 5H12C13.861 5 14.792 4.99999 15.545 5.23999C16.2948 5.4849 16.9763 5.90318 17.534 6.46094C18.0918 7.01869 18.5101 7.70015 18.755 8.44995C18.888 8.85995 18.949 9.32996 18.977 9.95996"
        stroke="black"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const AssignedWorkflowIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke-linecap="round"
      stroke-linejoin="round"
      height="22px"
      width="22px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 21a8 8 0 0 1 13.292-6"></path>
      <circle cx="10" cy="8" r="5"></circle>
      <path d="m16 19 2 2 4-4"></path>
    </svg>
  );
};
export const UserIcon = () => {
  return (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 7H3M1 15H3M10 21H12C14.8 21 16.2 21 17.27 20.46C18.2109 19.9785 18.9756 19.212 19.455 18.27C20 17.2 20 15.8 20 13V9C20 6.2 20 4.79998 19.455 3.72998C18.9756 2.78796 18.2109 2.02154 17.27 1.54004C16.2 1.00004 14.8 1 12 1H10C7.2 1 5.8 1.00004 4.73 1.54004C3.78908 2.02154 3.02435 2.78796 2.545 3.72998C2 4.79998 2 6.2 2 9V13C2 15.8 2 17.2 2.545 18.27C3.02435 19.212 3.78908 19.9785 4.73 20.46C5.8 21 7.2 21 10 21ZM13.222 7.77002C13.222 9.00002 12.227 9.98999 11 9.98999C10.7083 9.99038 10.4193 9.93318 10.1497 9.82178C9.88004 9.71038 9.63502 9.54702 9.42863 9.34082C9.22225 9.13462 9.05856 8.88965 8.94691 8.62012C8.83527 8.35058 8.77787 8.06176 8.778 7.77002C8.778 6.54002 9.773 5.55005 11 5.55005C12.227 5.55005 13.222 6.54002 13.222 7.77002ZM8.778 12.6699C7.55 12.6699 6.556 13.6599 6.556 14.8899C6.556 15.4999 7.05301 16 7.66701 16H14.333C14.947 16 15.444 15.4999 15.444 14.8899C15.444 13.6599 14.45 12.6699 13.222 12.6699H8.778Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UsersIcon = () => {
  return (
    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4688 1.53497C17.6647 2.22697 18.4688 3.519 18.4688 5C18.4691 5.70234 18.2845 6.39239 17.9333 7.00067C17.5822 7.60895 17.0771 8.11403 16.4688 8.46503M20.4688 18.732C21.0667 18.387 21.4688 17.74 21.4688 17C21.4691 16.2977 21.2845 15.6076 20.9333 14.9993C20.5822 14.391 20.0771 13.886 19.4688 13.535M13.4688 5C13.4688 6.06087 13.0473 7.07828 12.2972 7.82843C11.547 8.57858 10.5296 9 9.46875 9C8.40788 9 7.39047 8.57858 6.64032 7.82843C5.89017 7.07828 5.46875 6.06087 5.46875 5C5.46875 3.93913 5.89017 2.92172 6.64032 2.17157C7.39047 1.42142 8.40788 1 9.46875 1C10.5296 1 11.547 1.42142 12.2972 2.17157C13.0473 2.92172 13.4688 3.93913 13.4688 5ZM5.46875 13H13.4688C14.5296 13 15.547 13.4214 16.2972 14.1716C17.0473 14.9217 17.4688 15.9391 17.4688 17C17.4688 17.5304 17.258 18.0391 16.883 18.4142C16.5079 18.7893 15.9992 19 15.4688 19H3.46875C2.93832 19 2.42961 18.7893 2.05453 18.4142C1.67946 18.0391 1.46875 17.5304 1.46875 17C1.46875 15.9391 1.89017 14.9217 2.64032 14.1716C3.39047 13.4214 4.40788 13 5.46875 13Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UserWhiteIcon = () => {
  return (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4688 5C13.4688 6.06087 13.0473 7.07828 12.2972 7.82843C11.547 8.57858 10.5296 9 9.46875 9C8.40788 9 7.39047 8.57858 6.64032 7.82843C5.89017 7.07828 5.46875 6.06087 5.46875 5C5.46875 3.93913 5.89017 2.92172 6.64032 2.17157C7.39047 1.42142 8.40788 1 9.46875 1C10.5296 1 11.547 1.42142 12.2972 2.17157C13.0473 2.92172 13.4688 3.93913 13.4688 5ZM13.4688 13H5.46875C4.40788 13 3.39047 13.4214 2.64032 14.1716C1.89017 14.9217 1.46875 15.9391 1.46875 17C1.46875 17.5304 1.67946 18.0391 2.05453 18.4142C2.42961 18.7893 2.93832 19 3.46875 19H15.4688C15.9992 19 16.5079 18.7893 16.883 18.4142C17.258 18.0391 17.4688 17.5304 17.4688 17C17.4688 15.9391 17.0473 14.9217 16.2972 14.1716C15.547 13.4214 14.5296 13 13.4688 13Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.54175 9.01001L10.5547 13.02C12.4565 9.09712 15.4821 5.82852 19.2467 3.63L19.4688 3.5M19.4597 8C19.4687 8.58 19.4688 9.24 19.4688 10C19.4688 12.8 19.4687 14.19 19.0117 15.3C18.7099 16.0269 18.2678 16.6871 17.7106 17.243C17.1535 17.799 16.4923 18.2397 15.7648 18.54C14.6618 19 13.2648 19 10.4688 19C7.67275 19 6.27574 19 5.17274 18.54C4.44523 18.2397 3.78402 17.799 3.22688 17.243C2.66975 16.6871 2.22762 16.0269 1.92575 15.3C1.46875 14.19 1.46875 12.8 1.46875 10C1.46875 7.2 1.46875 5.80995 1.92575 4.69995C2.22762 3.97308 2.66975 3.31289 3.22688 2.75696C3.78402 2.20103 4.44523 1.76026 5.17274 1.45996C6.27574 0.999961 7.67275 1 10.4688 1C13.0208 1 14.4078 0.999976 15.4688 1.34998"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CheckNormalIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      class="bi bi-check"
      viewBox="0 0 16 16"
    >
      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"></path>
    </svg>
  );
};

export const CallIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.39171 10.9822C2.15335 8.88993 1.33847 6.43723 1.01711 3.71424C0.875958 2.51292 1.61777 1.25162 2.88116 1.0514C3.2786 0.981326 3.76913 0.991317 4.17358 1.03136C5.85843 1.18153 6.55519 2.67312 6.9246 4.1147C7.16798 5.06318 7.1504 6.05979 6.87372 6.99909C6.59703 7.9384 6.07154 8.78542 5.35287 9.45051C4.7482 10.0111 4.04643 10.4817 3.39171 10.9822ZM3.39171 10.9822C4.69165 13.2016 6.51626 15.0682 8.70555 16.4182M8.70555 16.4182C10.8719 17.7697 13.4247 18.6506 16.2859 18.981C17.4832 19.1312 18.7436 18.3804 18.9508 17.119C19.0209 16.6885 19.0129 16.188 18.9618 15.7575C18.7516 13.9855 17.0457 13.3148 15.522 12.9644C14.6677 12.7683 13.7786 12.7815 12.9305 13.0029C12.0824 13.2242 11.3002 13.6472 10.6507 14.2358C9.9359 14.8865 9.33824 15.6975 8.70555 16.4182Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const VideoIcon = () => {
  return (
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.001 9.93005C16.02 10.5001 16.278 11.03 16.714 11.4L17.714 12.24C19.015 13.33 21 12.41 21 10.71V5.29004C21 3.59004 19.015 2.67001 17.714 3.76001L16.714 4.59998C16.28 4.95998 16.022 5.49006 16.001 6.06006M16.001 9.93005L16 11C16 12.0609 15.5786 13.0782 14.8284 13.8284C14.0783 14.5785 13.0609 15 12 15H5C3.93913 15 2.92172 14.5785 2.17157 13.8284C1.42142 13.0782 1 12.0609 1 11V5C1 3.93913 1.42142 2.92178 2.17157 2.17163C2.92172 1.42149 3.93913 1 5 1H12C13.0609 1 14.0783 1.42149 14.8284 2.17163C15.5786 2.92178 16 3.93913 16 5L16.001 6.06006M16.001 9.93005V6.06006"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const HomeIcon = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.524 18.9991V13.9991C13.524 13.2034 13.2079 12.4404 12.6453 11.8778C12.0827 11.3152 11.3196 10.9991 10.524 10.9991C9.72834 10.9991 8.96527 11.3152 8.40266 11.8778C7.84006 12.4404 7.52399 13.2034 7.52399 13.9991V18.9991M6.12999 3.64908L3.52998 6.10509C2.78998 6.80309 2.42099 7.15208 2.15599 7.56508C1.92132 7.93152 1.74804 8.33382 1.64299 8.75609C1.52399 9.23209 1.52399 9.74109 1.52399 10.7581V12.5991C1.52399 14.8391 1.52398 15.9591 1.95998 16.8151C2.34296 17.5681 2.95501 18.1801 3.70799 18.5631C4.56399 18.9991 5.68398 18.9991 7.92398 18.9991H13.124C15.364 18.9991 16.484 18.9991 17.34 18.5631C18.093 18.1801 18.705 17.5681 19.088 16.8151C19.524 15.9591 19.524 14.8391 19.524 12.5991V10.7581C19.524 9.74109 19.524 9.23209 19.405 8.75609C19.2999 8.33382 19.1267 7.93152 18.892 7.56508C18.627 7.15208 18.258 6.80309 17.518 6.10509L14.918 3.64908C13.372 2.18908 12.599 1.45809 11.717 1.18309C10.9402 0.940108 10.1078 0.940108 9.33099 1.18309C8.44899 1.45809 7.67599 2.18908 6.12999 3.64908Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ReportIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 19H5C3.93913 19 2.92172 18.5786 2.17157 17.8284C1.42142 17.0783 1 16.0609 1 15V1M6 15V11M11 15V4M16 15V7"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CalendarIcon = () => {
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 1V3.13M6 3.13V5M6 3.13C5.502 3.2 5.08499 3.29996 4.70399 3.45996C3.97648 3.76026 3.31527 4.20103 2.75813 4.75696C2.201 5.31289 1.75887 5.97308 1.457 6.69995C1.203 7.31995 1.091 8.02 1.04 9M6 3.13C6.941 3 8.172 3 10 3C11.828 3 13.059 3 14 3.13M14 1V3.13M14 3.13V5M14 3.13C14.498 3.2 14.915 3.29996 15.296 3.45996C16.0235 3.76026 16.6847 4.20103 17.2419 4.75696C17.799 5.31289 18.2411 5.97308 18.543 6.69995C18.797 7.31995 18.909 8.02 18.96 9M18.96 9C19 9.79 19 10.76 19 12C19 14.8 19 16.19 18.543 17.3C18.2411 18.0269 17.799 18.6871 17.2419 19.243C16.6847 19.799 16.0235 20.2397 15.296 20.54C14.193 21 12.796 21 10 21C7.204 21 5.80699 21 4.70399 20.54C3.97648 20.2397 3.31527 19.799 2.75813 19.243C2.201 18.6871 1.75887 18.0269 1.457 17.3C1 16.19 1 14.8 1 12C1 10.76 1 9.79 1.04 9M18.96 9H1.04M6.00999 13H6M6.00999 17H6M10.01 13H10M10.01 17H10M14.01 13H14M14.01 17H14"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const PDFIcon = () => {
  return (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.88889 1H11C13.3575 1 15.6184 1.97607 17.2854 3.71325C18.9524 5.45043 19.8889 7.80642 19.8889 10.2632V11.4211C19.8889 9.49895 18.3967 7.94737 16.5556 7.94737H15.8889C15.4755 7.94737 15.27 7.94735 15.0967 7.92419C14.6325 7.84589 14.2041 7.61676 13.8724 7.26948C13.5407 6.9222 13.3229 6.47462 13.25 5.99059C13.2222 5.81691 13.2222 5.59696 13.2222 5.16853V4.47368C13.2222 2.55158 11.73 1 9.88889 1ZM9.88889 1H6.55556C5.37682 1 4.24635 1.48775 3.41286 2.35634C2.57936 3.22493 2.11111 4.40321 2.11111 5.63158V11.4211M1 23V14.8947H2.66667C3.40338 14.8947 4.10991 15.1999 4.63085 15.7428C5.15178 16.2857 5.44444 17.0217 5.44444 17.7895C5.44444 18.5572 5.15178 19.2933 4.63085 19.8361C4.10991 20.379 3.40338 20.6842 2.66667 20.6842H1M16.5556 23V14.8947H21M21 19.5263H16.5556M8.77778 14.8947V23H9.33333C11.4811 23 13.2222 21.1821 13.2222 18.9474C13.2222 16.7126 11.4811 14.8947 9.33333 14.8947H8.77778Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CallPLusIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.87542 10.9703C2.63842 8.88029 1.82442 6.43028 1.50342 3.71028C1.36242 2.51028 2.10342 1.25037 3.36542 1.05037C3.76242 0.98037 4.25242 0.99035 4.65642 1.03035C6.33942 1.18035 7.03542 2.67031 7.40442 4.11031C7.64754 5.05775 7.62997 6.05326 7.3536 6.99153C7.07722 7.92981 6.55231 8.7759 5.83442 9.44026C5.23042 10.0003 4.52942 10.4703 3.87542 10.9703ZM3.87542 10.9703C5.17392 13.1872 6.99654 15.0518 9.18342 16.4003M9.18342 16.4003C11.3474 17.7503 13.8974 18.6303 16.7554 18.9603C17.9514 19.1103 19.2104 18.3603 19.4174 17.1003C19.4874 16.6703 19.4794 16.1703 19.4284 15.7403C19.2184 13.9703 17.5144 13.3003 15.9924 12.9503C15.139 12.7544 14.2509 12.7676 13.4037 12.9887C12.5565 13.2098 11.7753 13.6324 11.1264 14.2203C10.4124 14.8703 9.81542 15.6803 9.18342 16.4003ZM12.4684 5.00032H15.4684M15.4684 5.00032H18.4684M15.4684 5.00032V2.00032M15.4684 5.00032V8.00032"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CallPLusIconActive = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.87542 10.9703C2.63842 8.88029 1.82442 6.43028 1.50342 3.71028C1.36242 2.51028 2.10342 1.25037 3.36542 1.05037C3.76242 0.98037 4.25242 0.99035 4.65642 1.03035C6.33942 1.18035 7.03542 2.67031 7.40442 4.11031C7.64754 5.05775 7.62997 6.05326 7.3536 6.99153C7.07722 7.92981 6.55231 8.7759 5.83442 9.44026C5.23042 10.0003 4.52942 10.4703 3.87542 10.9703ZM3.87542 10.9703C5.17392 13.1872 6.99654 15.0518 9.18342 16.4003M9.18342 16.4003C11.3474 17.7503 13.8974 18.6303 16.7554 18.9603C17.9514 19.1103 19.2104 18.3603 19.4174 17.1003C19.4874 16.6703 19.4794 16.1703 19.4284 15.7403C19.2184 13.9703 17.5144 13.3003 15.9924 12.9503C15.139 12.7544 14.2509 12.7676 13.4037 12.9887C12.5565 13.2098 11.7753 13.6324 11.1264 14.2203C10.4124 14.8703 9.81542 15.6803 9.18342 16.4003ZM12.4684 5.00032H15.4684M15.4684 5.00032H18.4684M15.4684 5.00032V2.00032M15.4684 5.00032V8.00032"
        stroke="#2f3a79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DocumentsIcon = () => {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.59998 1.0464V1.96C9.59998 3.304 9.59997 3.976 9.86157 4.4896C10.0921 4.94088 10.4591 5.30791 10.9104 5.5384C11.424 5.8 12.096 5.8 13.44 5.8H14.3536M9.59998 1.0464C9.28478 0.999999 8.90877 1 8.27917 1H6.71997C4.92797 1 4.03198 1 3.34718 1.3488C2.74479 1.65519 2.25516 2.14482 1.94878 2.7472C1.59998 3.432 1.59998 4.328 1.59998 6.12V11.88C1.59998 13.672 1.59998 14.568 1.94878 15.2528C2.25516 15.8552 2.74479 16.3448 3.34718 16.6512C4.03198 17 4.92797 17 6.71997 17H9.27998C11.072 17 11.968 17 12.6528 16.6512C13.2552 16.3448 13.7448 15.8552 14.0512 15.2528C14.4 14.568 14.4 13.672 14.4 11.88V7.1208C14.4 6.4912 14.4 6.1152 14.3536 5.8M9.59998 1.0464C9.67678 1.0576 9.74957 1.07119 9.82157 1.08879C10.148 1.16719 10.46 1.296 10.7464 1.4712C11.0696 1.6696 11.3464 1.9464 11.9 2.5L12.9 3.5C13.4536 4.0536 13.7304 4.3304 13.9288 4.6536C14.104 4.94 14.2328 5.25201 14.3112 5.57841C14.3288 5.65041 14.3424 5.7232 14.3536 5.8"
        stroke="#303A47"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const TimeIcon = () => {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99998 1V4.2M7.99998 4.2C6.30259 4.2 4.67472 4.87428 3.47449 6.07451C2.27425 7.27474 1.59998 8.90261 1.59998 10.6C1.59998 12.2974 2.27425 13.9253 3.47449 15.1255C4.67472 16.3257 6.30259 17 7.99998 17C9.69736 17 11.3252 16.3257 12.5255 15.1255C13.7257 13.9253 14.4 12.2974 14.4 10.6C14.4 8.90261 13.7257 7.27474 12.5255 6.07451C11.3252 4.87428 9.69736 4.2 7.99998 4.2ZM6.39998 1H9.59998M13.6 3.4L14.4 4.2M10.1216 8.27839L7.85837 10.5416"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DownloadIcon = () => {
  return (
    <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 12C1.5 14.76 3.739 17 6.5 17H14.5C17.261 17 19.5 14.76 19.5 12M7.5 9.18994C8.24 10.1799 9.099 11.0701 10.056 11.8401C10.186 11.9501 10.343 12 10.5 12M10.5 12C10.6624 12.0014 10.8198 11.9447 10.944 11.8401C11.901 11.0701 12.76 10.1799 13.5 9.18994M10.5 12V1"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const UploadIcon = () => {
  return (
    <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 12C1.5 14.76 3.739 17 6.5 17H14.5C17.261 17 19.5 14.76 19.5 12M7.5 3.81008C8.24 2.82008 9.099 1.92994 10.056 1.15994C10.1802 1.05531 10.3376 0.998642 10.5 1.00002M10.5 1.00002C10.6624 0.998642 10.8198 1.05531 10.944 1.15994C11.901 1.92994 12.76 2.82008 13.5 3.81008M10.5 1.00002V12"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const NavigatorIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1410_7821)">
        <path
          d="M5.72727 2.86364C5.72727 1.28209 4.44518 0 2.86364 0C1.28209 0 0 1.28209 0 2.86364C0 4.44518 1.28209 5.72727 2.86364 5.72727C4.44518 5.72727 5.72727 4.44518 5.72727 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 2.86364C15.4546 1.28209 14.1725 0 12.5909 0C11.0094 0 9.72729 1.28209 9.72729 2.86364C9.72729 4.44518 11.0094 5.72727 12.5909 5.72727C14.1725 5.72727 15.4546 4.44518 15.4546 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 2.86364C25.1818 1.28209 23.8997 0 22.3182 0C20.7366 0 19.4545 1.28209 19.4545 2.86364C19.4545 4.44518 20.7366 5.72727 22.3182 5.72727C23.8997 5.72727 25.1818 4.44518 25.1818 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M5.72727 12.5909C5.72727 11.0094 4.44518 9.72726 2.86364 9.72726C1.28209 9.72726 0 11.0094 0 12.5909C0 14.1724 1.28209 15.4545 2.86364 15.4545C4.44518 15.4545 5.72727 14.1724 5.72727 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 12.5909C15.4546 11.0094 14.1725 9.72726 12.5909 9.72726C11.0094 9.72726 9.72729 11.0094 9.72729 12.5909C9.72729 14.1724 11.0094 15.4545 12.5909 15.4545C14.1725 15.4545 15.4546 14.1724 15.4546 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 12.5909C25.1818 11.0094 23.8997 9.72726 22.3182 9.72726C20.7366 9.72726 19.4545 11.0094 19.4545 12.5909C19.4545 14.1724 20.7366 15.4545 22.3182 15.4545C23.8997 15.4545 25.1818 14.1724 25.1818 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M5.72727 22.3182C5.72727 20.7366 4.44518 19.4545 2.86364 19.4545C1.28209 19.4545 0 20.7366 0 22.3182C0 23.8997 1.28209 25.1818 2.86364 25.1818C4.44518 25.1818 5.72727 23.8997 5.72727 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 22.3182C15.4546 20.7366 14.1725 19.4545 12.5909 19.4545C11.0094 19.4545 9.72729 20.7366 9.72729 22.3182C9.72729 23.8997 11.0094 25.1818 12.5909 25.1818C14.1725 25.1818 15.4546 23.8997 15.4546 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 22.3182C25.1818 20.7366 23.8997 19.4545 22.3182 19.4545C20.7366 19.4545 19.4545 20.7366 19.4545 22.3182C19.4545 23.8997 20.7366 25.1818 22.3182 25.1818C23.8997 25.1818 25.1818 23.8997 25.1818 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1410_7821">
          <rect width="26" height="25.1818" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DeleteIcon = () => (
  <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4181 5.49908L12.3121 3.28809C12.0433 2.75076 11.6301 2.2989 11.119 1.98309C10.6079 1.66729 10.0189 1.5 9.41809 1.5C8.81727 1.5 8.22831 1.66729 7.71718 1.98309C7.20605 2.2989 6.79293 2.75076 6.52409 3.28809L5.41809 5.49908M1.41809 5.49908H17.4181M7.41809 10.4991V15.4991M11.4181 10.4991V15.4991M3.41809 5.49908H15.4181V14.4991C15.4181 16.3631 15.4181 17.2951 15.1141 18.0301C14.7079 19.0102 13.9292 19.7889 12.9491 20.1951C12.2141 20.4991 11.2821 20.4991 9.41809 20.4991C7.55409 20.4991 6.62208 20.4991 5.88708 20.1951C4.90697 19.7889 4.12826 19.0102 3.72209 18.0301C3.41809 17.2951 3.41809 16.3631 3.41809 14.4991V5.49908Z"
      stroke="#CA373C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditIcon = () => {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.4222 13.0012C19.4222 15.8012 19.4222 17.2013 18.8772 18.2713C18.4003 19.2126 17.6346 19.9764 16.6922 20.4512C15.6222 21.0012 14.2222 21.0012 11.4222 21.0012H9.42224C6.62224 21.0012 5.22224 21.0012 4.15224 20.4512C3.20984 19.9764 2.44416 19.2126 1.96724 18.2713C1.42224 17.2013 1.42224 15.8012 1.42224 13.0012V11.0012C1.42224 8.20125 1.42224 6.80123 1.96724 5.73123C2.44659 4.78921 3.21132 4.02279 4.15224 3.54129C5.22224 3.00129 6.62224 3.00125 9.42224 3.00125M7.48424 12.5012C7.49224 12.1512 7.49725 11.9813 7.53925 11.8113C7.57725 11.6613 7.63625 11.5313 7.71625 11.4013C7.80525 11.2513 7.92924 11.1313 8.17624 10.8813L17.5722 1.4313C17.8083 1.19426 18.1184 1.04508 18.451 1.00869C18.7835 0.972308 19.1185 1.05084 19.4002 1.23123C20.0877 1.67875 20.6745 2.26448 21.1232 2.9512C21.1482 2.9812 21.1742 3.02131 21.1982 3.06131C21.5742 3.67131 21.4512 4.4313 20.9582 4.9313L11.6362 14.3013C11.3792 14.5613 11.2512 14.6913 11.1022 14.7813C10.9685 14.8614 10.8241 14.9219 10.6732 14.9612C10.5032 15.0012 10.3222 15.0012 9.95924 15.0012H7.42224L7.48424 12.5012Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PLusIconDark = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 448 512"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"></path>
    </svg>
  );
};
export const PLusIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 15V8M8 8V1M8 8H1M8 8H15"
        stroke="#2F3A79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MinusIcon = () => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-q7mezt"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      data-testid="RemoveOutlinedIcon"
    >
      <path d="M19 13H5v-2h14z"></path>
    </svg>
  );
};

export const RemoveIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.05025 10.9498L6 6.00008M6 6.00008L10.9497 1.05033M6 6.00008L1.05025 1.05033M6 6.00008L10.9497 10.9498"
        stroke="#2F3A79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 1H1V3.89453C1 4.18512 1.11156 4.47593 1.31131 4.6771L7.06369 10.7347C7.26344 10.9358 7.375 11.2266 7.375 11.5172V16.6471L11.625 20V11.5172C11.625 11.2266 11.7366 10.9358 11.9363 10.7347L17.6887 4.6771C17.7875 4.57509 17.866 4.45346 17.9194 4.31911C17.9729 4.18475 18.0003 4.04018 18 3.89453V1Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 19L12.95 12.95M12.95 12.95C13.6003 12.3001 14.1161 11.5285 14.4678 10.6791C14.8196 9.8297 15.0004 8.91933 15 8C15 4.13 11.866 1 8 1C4.134 1 1 4.13 1 8C1 11.87 4.134 15 8 15C9.933 15 11.683 14.22 12.95 12.95Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const NotifyIcon = () => {
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.0006 17.0415C5.68429 16.9787 4.3703 16.8743 3.06059 16.7285C2.8123 16.7009 2.57331 16.6181 2.36113 16.4863C2.14894 16.3544 1.96892 16.1768 1.83424 15.9663C1.69955 15.7559 1.61361 15.518 1.5827 15.2701C1.55179 15.0222 1.57669 14.7706 1.65559 14.5335C1.82659 14.0205 1.99859 13.5155 2.04459 12.9715L2.41859 8.47552C2.5777 6.57423 3.44537 4.80211 4.84961 3.51047C6.25385 2.21883 8.09215 1.50195 10.0001 1.50195C11.908 1.50195 13.7463 2.21883 15.1506 3.51047C16.5548 4.80211 17.4225 6.57423 17.5816 8.47552L17.9566 12.9745C18.0016 13.5175 18.1736 14.0225 18.3446 14.5355C18.4231 14.7724 18.4478 15.0239 18.4167 15.2716C18.3856 15.5192 18.2996 15.7568 18.1649 15.967C18.0303 16.1771 17.8504 16.3546 17.6384 16.4863C17.4264 16.6181 17.1877 16.7008 16.9396 16.7285C15.6296 16.8735 14.3156 16.9785 13.0006 17.0405M7.0006 17.0415V17.4995C7.0006 18.2952 7.31666 19.0582 7.87927 19.6208C8.44188 20.1834 9.20495 20.4995 10.0006 20.4995C10.7962 20.4995 11.5593 20.1834 12.1219 19.6208C12.6845 19.0582 13.0006 18.2952 13.0006 17.4995V17.0405M7.0006 17.0415C8.9996 17.1365 11.0016 17.1365 13.0006 17.0405M9.99959 12.4995V6.49951M6.99959 9.49951H12.9996"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DeleteRedIcon = () => {
  return (
    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 5.49908L11.894 3.28809C11.6252 2.75076 11.212 2.2989 10.7009 1.98309C10.1898 1.66729 9.60082 1.5 9 1.5C8.39918 1.5 7.81022 1.66729 7.29909 1.98309C6.78796 2.2989 6.37484 2.75076 6.106 3.28809L5 5.49908M1 5.49908H17M7 10.4991V15.4991M11 10.4991V15.4991M3 5.49908H15V14.4991C15 16.3631 15 17.2951 14.696 18.0301C14.2898 19.0102 13.5111 19.7889 12.531 20.1951C11.796 20.4991 10.864 20.4991 9 20.4991C7.136 20.4991 6.20399 20.4991 5.46899 20.1951C4.48888 19.7889 3.71017 19.0102 3.304 18.0301C3 17.2951 3 16.3631 3 14.4991V5.49908Z"
        stroke="#CA373C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg fill="#fff" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
    </svg>
  );
};

export const ScheduleIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 6.00009V10.8161C10 10.9003 10.0213 10.9831 10.0619 11.0569C10.1024 11.1306 10.1609 11.193 10.232 11.2381L13 13.0001M19 10.0001C19 12.0823 18.278 14.1001 16.957 15.7096C15.6361 17.3192 13.7979 18.4209 11.7557 18.8271C9.71355 19.2333 7.5937 18.9188 5.75737 17.9373C3.92104 16.9557 2.48187 15.3678 1.68506 13.4441C0.888253 11.5204 0.783114 9.37992 1.38756 7.38739C1.992 5.39486 3.26863 3.67355 4.99992 2.51675C6.73121 1.35996 8.81004 0.839253 10.8822 1.04336C12.9544 1.24746 14.8917 2.16375 16.364 3.63609C17.1997 4.47183 17.8627 5.46399 18.3149 6.55592C18.7672 7.64786 19 8.81819 19 10.0001Z"
        stroke="#303A47"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const defaultLogo = `${CDN_URL}/sso/logos/default_simulanis.png`;

export const AssignWorkIcon = () => {
  return (
    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.88325 4.5273H19.7833M9.85512 1.5H16.8113M25.3333 13.7859V18.5477C25.3333 22.7143 22.9333 24.5 19.3333 24.5H7.33325C3.73325 24.5 1.33325 22.7143 1.33325 18.5477V13.7859C1.33325 10.6312 2.71325 8.84552 4.93325 8.16696C5.65325 7.94078 6.45725 7.8336 7.33325 7.8336H19.3333C20.2093 7.8336 21.0133 7.94078 21.7333 8.16696C23.9533 8.84552 25.3333 10.6312 25.3333 13.7859Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const AssignWorkIconActive = () => {
  return (
    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.88325 4.5273H19.7833M9.85512 1.5H16.8113M25.3333 13.7859V18.5477C25.3333 22.7143 22.9333 24.5 19.3333 24.5H7.33325C3.73325 24.5 1.33325 22.7143 1.33325 18.5477V13.7859C1.33325 10.6312 2.71325 8.84552 4.93325 8.16696C5.65325 7.94078 6.45725 7.8336 7.33325 7.8336H19.3333C20.2093 7.8336 21.0133 7.94078 21.7333 8.16696C23.9533 8.84552 25.3333 10.6312 25.3333 13.7859Z"
        stroke="#2f3a79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const BottomActiveBar = () => {
  return (
    <svg width="52" height="3" viewBox="0 0 52 3" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M49 3C50.6569 3 52 1.65685 52 -2.38419e-06L-1.31134e-07 -1.11194e-07C-5.87108e-08 1.65686 1.34315 3 3 3L49 3Z"
        fill="url(#paint0_linear_5101_18217)"
        fill-opacity="0.6"
      />
      <path
        d="M49 3C50.6569 3 52 1.65685 52 -2.38419e-06L-1.31134e-07 -1.11194e-07C-5.87108e-08 1.65686 1.34315 3 3 3L49 3Z"
        fill="#2F3A79"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5101_18217"
          x1="26"
          y1="3"
          x2="26"
          y2="-1.24769e-06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2F3A79" />
          <stop offset="1" stop-color="#CA373C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const TeamDashboardActive = () => {
  return (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.1945 22.205C2.25879 21.229 1.79093 20.735 1.61608 20.1791C1.46131 19.6849 1.46131 19.1411 1.61608 18.6469C1.79093 18.091 2.25879 17.597 3.1945 16.621L3.69542 16.0899C4.63113 15.1139 5.09899 14.6196 5.63891 14.4467C6.11385 14.2861 6.62422 14.2861 7.09917 14.4467C7.63909 14.6196 8.10694 15.1139 9.04265 16.0899L9.54358 16.621C10.4793 17.597 10.9471 18.091 11.122 18.6469C11.2768 19.1411 11.2768 19.6849 11.122 20.1791C10.9471 20.735 10.4793 21.229 9.54358 22.205L9.04265 22.7361C8.10694 23.7121 7.63909 24.2064 7.09917 24.3793C6.62422 24.5399 6.11385 24.5399 5.63891 24.3793C5.09899 24.2064 4.63113 23.7121 3.69542 22.7361L3.1945 22.205Z"
        fill="#2F3A79"
      />
      <path
        d="M2.23398 5.45296C2.23398 4.06932 2.23398 3.37767 2.49153 2.84645C2.71837 2.38935 3.07989 2.00623 3.52411 1.77151C4.02977 1.49972 4.69138 1.49976 6.0146 1.49976H6.72347C8.04669 1.49976 8.70831 1.49972 9.21396 1.77151C9.65819 2.00623 10.0197 2.38935 10.2465 2.84645C10.5041 3.37767 10.5041 4.06932 10.5041 5.45296V6.19432C10.5041 7.57796 10.5041 8.26961 10.2465 8.80083C10.0197 9.25793 9.65819 9.64105 9.21396 9.87577C8.70831 10.1476 8.04669 10.1475 6.72347 10.1475H6.0146C4.69138 10.1475 4.02977 10.1476 3.52411 9.87577C3.07989 9.64105 2.71837 9.25793 2.49153 8.80083C2.23398 8.26961 2.23398 7.57796 2.23398 6.19432V5.45296ZM3.1945 22.205C2.25879 21.229 1.79093 20.735 1.61608 20.1791C1.46131 19.6849 1.46131 19.1411 1.61608 18.6469C1.79093 18.091 2.25879 17.5969 3.1945 16.621L3.69542 16.0898C4.63113 15.1139 5.09899 14.6196 5.63891 14.4467C6.11385 14.2861 6.62422 14.2861 7.09917 14.4467C7.63909 14.6196 8.10694 15.1139 9.04265 16.0898L9.54358 16.621C10.4793 17.5969 10.9471 18.091 11.122 18.6469C11.2768 19.1411 11.2768 19.6849 11.122 20.1791C10.9471 20.735 10.4793 21.229 9.54358 22.205L9.04265 22.7361C8.10694 23.7121 7.63909 24.2064 7.09917 24.3793C6.62422 24.5399 6.11385 24.5399 5.63891 24.3793C5.09899 24.2064 4.63113 23.7121 3.69542 22.7361L3.1945 22.205ZM15.2299 5.82364C15.2299 3.43933 17.0812 1.49976 19.3649 1.49976C21.6487 1.49976 23.5 3.43933 23.5 5.82364C23.5 8.20795 21.6487 10.1475 19.3649 10.1475C17.0812 10.1475 15.2299 8.20795 15.2299 5.82364ZM15.2299 19.0423C15.2299 17.6587 15.2299 16.967 15.4874 16.4358C15.7143 15.9787 16.0758 15.5956 16.52 15.3609C17.0257 15.0891 17.6873 15.0891 19.0105 15.0891H19.7194C21.0426 15.0891 21.7042 15.0891 22.2099 15.3609C22.6541 15.5956 23.0156 15.9787 23.2424 16.4358C23.5 16.967 23.5 17.6587 23.5 19.0423V19.7837C23.5 21.1673 23.5 21.859 23.2424 22.3902C23.0156 22.8473 22.6541 23.2304 22.2099 23.4651C21.7042 23.7369 21.0426 23.7369 19.7194 23.7369H19.0105C17.6873 23.7369 17.0257 23.7369 16.52 23.4651C16.0758 23.2304 15.7143 22.8473 15.4874 22.3902C15.2299 21.859 15.2299 21.1673 15.2299 19.7837V19.0423Z"
        stroke="#0F0F1C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const MyDashboardIconActive = () => {
  return (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 4.93329C1.5 3.62662 1.5 2.97345 1.75434 2.47178C1.97834 2.04011 2.33533 1.67831 2.77399 1.45664C3.27333 1.19998 3.92666 1.20001 5.23333 1.20001H5.93334C7.24 1.20001 7.89334 1.19998 8.39267 1.45664C8.83134 1.67831 9.18833 2.04011 9.41233 2.47178C9.66666 2.97345 9.66667 3.62662 9.66667 4.93329V7.96674C9.66667 9.2734 9.66666 9.92658 9.41233 10.4282C9.18833 10.8599 8.83134 11.2217 8.39267 11.4434C7.89334 11.7 7.24 11.7 5.93334 11.7H5.23333C3.92666 11.7 3.27333 11.7 2.77399 11.4434C2.33533 11.2217 1.97834 10.8599 1.75434 10.4282C1.5 9.92658 1.5 9.2734 1.5 7.96674V4.93329ZM14.3333 15.4333C14.3333 14.1266 14.3333 13.4734 14.5877 12.9718C14.8117 12.5401 15.1687 12.1783 15.6073 11.9566C16.1067 11.7 16.76 11.7 18.0667 11.7H18.7667C20.0733 11.7 20.7267 11.7 21.226 11.9566C21.6647 12.1783 22.0217 12.5401 22.2457 12.9718C22.5 13.4734 22.5 14.1266 22.5 15.4333V18.4667C22.5 19.7734 22.5 20.4266 22.2457 20.9282C22.0217 21.3599 21.6647 21.7217 21.226 21.9434C20.7267 22.2 20.0733 22.2 18.7667 22.2H18.0667C16.76 22.2 16.1067 22.2 15.6073 21.9434C15.1687 21.7217 14.8117 21.3599 14.5877 20.9282C14.3333 20.4266 14.3333 19.7734 14.3333 18.4667V15.4333Z"
        fill="#2F3A79"
      />
      <path
        d="M1.5 4.93329C1.5 3.62662 1.5 2.97345 1.75434 2.47178C1.97834 2.04011 2.33533 1.67831 2.77399 1.45664C3.27333 1.19998 3.92666 1.20001 5.23333 1.20001H5.93334C7.24 1.20001 7.89334 1.19998 8.39267 1.45664C8.83134 1.67831 9.18833 2.04011 9.41233 2.47178C9.66666 2.97345 9.66667 3.62662 9.66667 4.93329V7.96674C9.66667 9.2734 9.66666 9.92658 9.41233 10.4282C9.18833 10.8599 8.83134 11.2217 8.39267 11.4434C7.89334 11.7 7.24 11.7 5.93334 11.7H5.23333C3.92666 11.7 3.27333 11.7 2.77399 11.4434C2.33533 11.2217 1.97834 10.8599 1.75434 10.4282C1.5 9.92658 1.5 9.2734 1.5 7.96674V4.93329ZM1.5 19.2833C1.5 18.7467 1.5 18.4668 1.54434 18.2451C1.72867 17.3235 2.452 16.6001 3.37833 16.4134C3.6035 16.3667 3.87417 16.3667 4.41667 16.3667H6.75C7.2925 16.3667 7.56317 16.3667 7.78833 16.4134C8.71467 16.6001 9.43801 17.3235 9.62234 18.2451C9.66667 18.4668 9.66667 18.7467 9.66667 19.2833C9.66667 19.82 9.66667 20.0999 9.62234 20.3216C9.53111 20.7736 9.30837 21.1888 8.98208 21.5147C8.65579 21.8406 8.24048 22.0626 7.78833 22.1533C7.56317 22.2 7.2925 22.2 6.75 22.2H4.41667C3.87417 22.2 3.6035 22.2 3.37833 22.1533C2.92618 22.0626 2.51089 21.8406 2.1846 21.5147C1.85831 21.1888 1.63557 20.7736 1.54434 20.3216C1.5 20.0999 1.5 19.82 1.5 19.2833ZM14.3333 4.11668C14.3333 3.58001 14.3333 3.30014 14.3777 3.07847C14.562 2.1568 15.2853 1.43339 16.2117 1.24672C16.4368 1.20006 16.7075 1.20001 17.25 1.20001H19.5833C20.1258 1.20001 20.3965 1.20006 20.6217 1.24672C21.548 1.43339 22.2713 2.1568 22.4557 3.07847C22.5 3.30014 22.5 3.58001 22.5 4.11668C22.5 4.65335 22.5 4.93322 22.4557 5.15489C22.3644 5.60692 22.1417 6.02217 21.8154 6.34804C21.4891 6.67392 21.0738 6.89598 20.6217 6.98663C20.3965 7.0333 20.1258 7.03335 19.5833 7.03335H17.25C16.7075 7.03335 16.4368 7.0333 16.2117 6.98663C15.7595 6.89598 15.3442 6.67392 15.0179 6.34804C14.6916 6.02217 14.4689 5.60692 14.3777 5.15489C14.3333 4.93322 14.3333 4.65335 14.3333 4.11668ZM14.3333 15.4333C14.3333 14.1266 14.3333 13.4734 14.5877 12.9718C14.8117 12.5401 15.1687 12.1783 15.6073 11.9566C16.1067 11.7 16.76 11.7 18.0667 11.7H18.7667C20.0733 11.7 20.7267 11.7 21.226 11.9566C21.6647 12.1783 22.0217 12.5401 22.2457 12.9718C22.5 13.4734 22.5 14.1266 22.5 15.4333V18.4667C22.5 19.7734 22.5 20.4266 22.2457 20.9282C22.0217 21.3599 21.6647 21.7217 21.226 21.9434C20.7267 22.2 20.0733 22.2 18.7667 22.2H18.0667C16.76 22.2 16.1067 22.2 15.6073 21.9434C15.1687 21.7217 14.8117 21.3599 14.5877 20.9282C14.3333 20.4266 14.3333 19.7734 14.3333 18.4667V15.4333Z"
        stroke="#0F0F1C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const WorkIconActive = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 5.02002C6 4.09002 6.00001 3.60997 6.10201 3.21997C6.23976 2.71206 6.50813 2.24914 6.88043 1.8772C7.25273 1.50525 7.71596 1.23737 8.224 1.1001C8.605 1.0001 9.07 1 10 1C10.93 1 11.395 1.0001 11.776 1.1001C12.284 1.23737 12.7473 1.50525 13.1196 1.8772C13.4919 2.24914 13.7602 2.71206 13.898 3.21997C14 3.60997 14 4.09002 14 5.02002M10 13V15M1.023 9.95996C1.13687 11.0681 1.65768 12.0945 2.48468 12.8408C3.31168 13.5871 4.38607 14.0001 5.5 14H14.5C15.6139 14.0001 16.6883 13.5871 17.5153 12.8408C18.3423 12.0945 18.8631 11.0681 18.977 9.95996M1.023 9.95996C1 10.49 1 11.15 1 12C1 13.86 1 14.79 1.245 15.55C1.48992 16.2998 1.90823 16.9813 2.46599 17.5391C3.02374 18.0968 3.7052 18.5151 4.455 18.76C5.208 19 6.139 19 8 19H12C13.861 19 14.792 19 15.545 18.76C16.2948 18.5151 16.9763 18.0968 17.534 17.5391C18.0918 16.9813 18.5101 16.2998 18.755 15.55C19 14.79 19 13.86 19 12C19 11.15 19 10.49 18.977 9.95996M1.023 9.95996C1.051 9.32996 1.112 8.85995 1.245 8.44995C1.48992 7.70015 1.90823 7.01869 2.46599 6.46094C3.02374 5.90318 3.7052 5.4849 4.455 5.23999C5.208 4.99999 6.139 5 8 5H12C13.861 5 14.792 4.99999 15.545 5.23999C16.2948 5.4849 16.9763 5.90318 17.534 6.46094C18.0918 7.01869 18.5101 7.70015 18.755 8.44995C18.888 8.85995 18.949 9.32996 18.977 9.95996"
        stroke="#2f3a79"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const NoDataImage = () => {
  return (
    <svg width="345" height="287" viewBox="0 0 345 287" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3694_8732)">
        <g filter="url(#filter0_d_3694_8732)">
          <path
            d="M153.54 54.5382C153.473 54.5382 153.406 54.5358 153.339 54.5316C148.913 54.2473 133.77 52.1057 124.726 36.4726C124.058 35.3187 124.19 33.8504 125.055 32.8199C132.607 26.6791 138.507 20.033 141.989 12.6482C142.618 11.899 143.562 11.4895 144.517 11.5064C145.498 11.5295 146.401 11.9912 146.997 12.7729C151.29 18.4135 159.767 28.3988 168.297 31.8997C169.255 32.2936 169.949 33.0927 170.201 34.0937C170.45 35.0862 170.219 36.1094 169.567 36.9008L156.001 53.3699C155.391 54.1106 154.483 54.5382 153.54 54.5382Z"
            fill="#E6E6E6"
          />
          <path
            d="M127.854 33.8121C127.623 34.0879 127.581 34.4812 127.749 34.792C135.931 49.8536 150.558 51.0352 153.407 51.1189C153.682 51.1346 153.939 51.0111 154.113 50.7997L167.582 34.4493C167.773 34.2174 167.831 33.9217 167.744 33.6362C167.655 33.3496 167.438 33.1358 167.147 33.0515C157.999 30.3787 148.401 17.9989 145.677 14.2679C145.518 14.0499 145.272 13.9192 145.003 13.9102C144.726 13.9075 144.474 14.0162 144.297 14.2258C140.4 21.8228 134.943 28.3679 127.854 33.8121Z"
            fill="white"
          />
          <path
            d="M134.637 37.3389L146.846 24.8935C147.681 24.0427 146.373 22.7334 145.537 23.5853L133.328 36.0307C132.494 36.8814 133.801 38.1907 134.637 37.3389Z"
            fill="#E6E6E6"
          />
          <path
            d="M142.006 40.8469C145.375 37.8275 148.304 34.3315 150.701 30.4953C151.334 29.4827 149.734 28.5529 149.103 29.5615C146.785 33.2703 143.955 36.6199 140.697 39.5387C139.809 40.335 141.121 41.6399 142.006 40.8469Z"
            fill="#E6E6E6"
          />
          <path
            d="M148.648 45.0439C151.715 41.6463 154.327 37.8545 156.383 33.7643C156.916 32.7032 155.32 31.7653 154.785 32.8305C152.799 36.7824 150.304 40.4523 147.339 43.7356C146.543 44.6175 147.847 45.9299 148.648 45.0439Z"
            fill="#E6E6E6"
          />
        </g>
        <g filter="url(#filter1_d_3694_8732)">
          <path
            d="M164.643 59.4718C164.576 59.4718 164.509 59.4694 164.442 59.4652C160.017 59.1809 144.874 57.0393 135.83 41.4062C135.162 40.2522 135.294 38.784 136.158 37.7535C143.334 31.5317 148.736 24.7282 153.093 17.5818C153.722 16.8326 154.666 16.4231 155.621 16.44C156.601 16.4631 157.505 16.9248 158.1 17.7065C162.394 23.3471 170.871 33.3324 179.4 36.8333C180.359 37.2272 181.053 38.0263 181.304 39.0273C181.554 40.0198 181.323 41.043 180.671 41.8344L167.105 58.3034C166.495 59.0442 165.586 59.4718 164.643 59.4718Z"
            fill="#E6E6E6"
          />
          <path
            d="M138.958 38.7457C138.727 39.0215 138.685 39.4148 138.853 39.7256C147.035 54.7872 161.662 55.9688 164.511 56.0525C164.785 56.0682 165.042 55.9447 165.216 55.7333L178.686 39.3829C178.876 39.151 178.935 38.8553 178.847 38.5698C178.759 38.2832 178.541 38.0694 178.25 37.9851C169.103 35.3123 159.505 22.9325 156.781 19.2015C156.621 18.9835 156.375 18.8528 156.106 18.8438C155.829 18.8411 155.577 18.9498 155.401 19.1594C150.732 26.9152 145.48 33.7903 138.958 38.7457Z"
            fill="white"
          />
          <path
            d="M145.74 42.2725L157.95 29.8271C158.784 28.9763 157.477 27.667 156.641 28.5188L144.432 40.9643C143.597 41.815 144.905 43.1243 145.74 42.2725Z"
            fill="#E6E6E6"
          />
          <path
            d="M153.109 45.7805C156.479 42.7611 159.407 39.265 161.805 35.4289C162.438 34.4163 160.837 33.4865 160.207 34.4951C157.889 38.2039 155.058 41.5535 151.801 44.4722C150.912 45.2686 152.224 46.5735 153.109 45.7805Z"
            fill="#E6E6E6"
          />
          <path
            d="M159.751 49.9775C162.819 46.5799 165.43 42.7881 167.486 38.6979C168.02 37.6368 166.424 36.6989 165.888 37.7641C163.902 41.716 161.407 45.3859 158.443 48.6692C157.646 49.5511 158.951 50.8635 159.751 49.9775Z"
            fill="#E6E6E6"
          />
        </g>
        <g filter="url(#filter2_d_3694_8732)">
          <path
            d="M286.164 174.179C286.097 174.179 286.03 174.176 285.963 174.172C281.538 173.888 266.395 171.746 257.351 156.113C256.683 154.959 256.815 153.491 257.679 152.461L274.614 132.289C275.243 131.54 276.187 131.13 277.142 131.147C278.122 131.17 279.381 131.461 279.621 132.414C281.572 140.155 289.974 150.207 300.921 151.54C301.95 151.666 302.574 152.733 302.825 153.734C303.075 154.727 302.844 155.75 302.192 156.541L288.626 173.01C288.016 173.751 287.107 174.179 286.164 174.179Z"
            fill="#E6E6E6"
          />
          <path
            d="M260.479 153.453C260.248 153.729 260.206 154.122 260.374 154.433C268.556 169.494 283.183 170.676 286.032 170.76C286.306 170.775 286.563 170.652 286.737 170.44L300.207 154.09C300.397 153.858 300.456 153.562 300.368 153.277C300.28 152.99 300.074 152.706 299.771 152.692C288.127 152.146 278.775 139.557 278.302 133.909C278.279 133.64 277.896 133.56 277.627 133.551C277.35 133.548 277.098 133.657 276.922 133.866L260.479 153.453Z"
            fill="white"
          />
          <path
            d="M267.261 156.98L279.47 144.534C280.305 143.683 278.998 142.374 278.162 143.226L265.953 155.671C265.118 156.522 266.426 157.831 267.261 156.98Z"
            fill="#E6E6E6"
          />
          <path
            d="M274.63 160.487C278 157.468 280.928 153.972 283.326 150.136C283.959 149.123 282.358 148.194 281.728 149.202C279.41 152.911 276.579 156.261 273.322 159.179C272.433 159.976 273.745 161.28 274.63 160.487Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.272 164.684C284.34 161.287 286.951 157.495 289.007 153.405C289.541 152.344 287.945 151.406 287.409 152.471C285.423 156.423 282.928 160.093 279.964 163.376C279.167 164.258 280.472 165.571 281.272 164.684Z"
            fill="#E6E6E6"
          />
        </g>
        <path
          d="M311.53 276.311C312.804 276.391 313.509 274.808 312.544 273.885L312.449 273.504C312.461 273.474 312.474 273.443 312.487 273.413C313.775 270.34 318.143 270.362 319.421 273.438C320.555 276.169 321.999 278.905 322.355 281.792C322.514 283.067 322.442 284.365 322.159 285.616C324.817 279.812 326.215 273.475 326.215 267.102C326.215 265.501 326.128 263.9 325.948 262.302C325.801 260.996 325.598 259.697 325.335 258.411C323.913 251.456 320.833 244.832 316.39 239.299C314.255 238.132 312.474 236.308 311.398 234.121C311.012 233.333 310.709 232.484 310.565 231.62C310.808 231.652 311.482 227.951 311.299 227.724C311.637 227.21 312.243 226.955 312.613 226.454C314.453 223.96 316.988 224.395 318.311 227.784C321.137 229.21 321.165 231.576 319.43 233.85C318.327 235.298 318.175 237.256 317.207 238.805C317.307 238.933 317.41 239.056 317.51 239.184C319.336 241.526 320.916 244.043 322.248 246.688C321.872 243.749 322.427 240.208 323.375 237.925C324.453 235.324 326.474 233.134 328.254 230.886C330.392 228.185 334.777 229.363 335.153 232.787C335.157 232.82 335.16 232.853 335.164 232.886C334.9 233.036 334.641 233.194 334.388 233.361C332.944 234.315 333.443 236.552 335.153 236.816L335.192 236.822C335.096 237.774 334.933 238.718 334.694 239.646C336.977 248.475 332.047 251.69 325.008 251.835C324.853 251.914 324.701 251.994 324.546 252.07C325.259 254.077 325.829 256.136 326.251 258.224C326.63 260.068 326.893 261.932 327.04 263.804C327.223 266.166 327.207 268.54 327.008 270.898L327.02 270.814C327.526 268.217 328.937 265.792 330.985 264.111C334.035 261.605 338.345 260.683 341.637 258.669C343.221 257.699 345.251 258.952 344.975 260.788L344.961 260.876C344.471 261.076 343.993 261.307 343.531 261.565C343.266 261.715 343.007 261.873 342.754 262.04C341.311 262.995 341.81 265.231 343.52 265.495L343.559 265.501C343.587 265.505 343.61 265.509 343.638 265.513C342.798 267.508 341.626 269.361 340.16 270.958C338.732 278.665 332.6 279.396 326.04 277.152H326.036C325.319 280.275 324.271 283.326 322.924 286.233H311.809C311.769 286.11 311.733 285.982 311.697 285.859C312.725 285.923 313.761 285.863 314.773 285.676C313.948 284.664 313.123 283.644 312.299 282.633C312.279 282.613 312.263 282.593 312.247 282.573C311.828 282.055 311.406 281.541 310.988 281.023L310.988 281.023C310.961 279.433 311.152 277.849 311.53 276.311Z"
          fill="#F2F2F2"
        />
        <path
          d="M-19 286.5C-19 286.777 -18.4724 287 -17.8154 287H343.815C344.472 287 345 286.777 345 286.5C345 286.223 344.472 286 343.815 286H-17.8154C-18.4724 286 -19 286.223 -19 286.5Z"
          fill="#CCCCCC"
        />
        <g filter="url(#filter3_d_3694_8732)">
          <path d="M235.432 281.703L228.116 281.702L224.636 253.492L235.433 253.493L235.432 281.703Z" fill="#FFB6B6" />
          <path
            d="M210.368 281.537C210.14 281.92 210.02 283.158 210.02 283.604C210.02 284.975 211.132 286.086 212.503 286.086H235.158C236.093 286.086 236.852 285.328 236.852 284.393V283.45C236.852 283.45 237.972 280.616 235.665 277.123C235.665 277.123 232.797 279.858 228.512 275.574L227.248 273.285L218.101 279.973L213.031 280.597C211.922 280.734 210.939 280.576 210.368 281.537Z"
            fill="black"
          />
          <path d="M302.983 267.27L296.752 271.102L279.003 248.897L288.199 243.242L302.983 267.27Z" fill="#FFB6B6" />
          <path
            d="M281.549 280.257C281.556 280.703 282.102 281.821 282.336 282.2C283.055 283.368 284.584 283.732 285.752 283.014L305.048 271.146C305.845 270.656 306.093 269.613 305.603 268.817L305.109 268.014C305.109 268.014 304.578 265.013 300.782 263.246C300.782 263.246 299.773 267.078 293.878 265.674L291.602 264.387L287.316 274.875L283.325 278.062C282.452 278.759 281.531 279.14 281.549 280.257Z"
            fill="black"
          />
          <path
            d="M257.004 149.761C256.642 148.182 256.669 146.649 257.009 145.378L252.601 130.561L259.778 128.615L263.476 143.856C264.334 144.844 265.026 146.208 265.388 147.787C266.215 151.395 265.009 154.761 262.694 155.306C260.378 155.851 257.831 153.368 257.004 149.761Z"
            fill="#FFB6B6"
          />
          <path
            d="M216.17 50.9892C216.17 50.9892 227.736 45.9563 234.194 53.2292C240.072 59.8489 252.005 79.7687 250.779 81.7068L262.526 137.2L253.819 139.882L230.721 76.0517L216.17 50.9892Z"
            fill="#2F3A79"
          />
          <path
            d="M203.433 133.228L209.392 202.733L223.793 267.272L239.187 265.783L231.738 195.286L236.298 132.635L203.433 133.228Z"
            fill="black"
          />
          <path
            d="M204.665 148.309L241.781 207.381L284.13 258.176L297.135 249.808L258.241 190.535C252.288 164.426 245.695 140.257 233.614 132.744L204.665 148.309Z"
            fill="black"
          />
          <path
            d="M206.831 148.598C205.09 148.598 203.404 147.984 202.03 146.82C200.185 145.256 199.224 142.976 199.393 140.564L202.631 109.508L201.394 75.5954L201.402 75.5587L205.246 57.1299C205.284 56.5442 205.407 55.9242 205.605 55.3288L211.283 38.2629C212.304 35.1933 215.163 33.1309 218.399 33.1309H223.42C225.934 33.1309 228.267 34.379 229.661 36.47L234.056 43.061C234.348 43.4989 234.594 43.9689 234.788 44.4582L244.491 68.9405C244.799 69.7177 244.974 70.5353 245.012 71.3703L248.022 139.316C248.122 141.571 247.215 143.73 245.532 145.238C243.86 146.738 241.629 147.401 239.416 147.059C226.746 145.103 215.657 146.703 208.584 148.39C208 148.529 207.412 148.598 206.831 148.598Z"
            fill="#2F3A79"
          />
          <path
            d="M205.419 81.0995L196.978 74.6456C196.978 74.6456 200.95 39.397 211.379 39.397C221.807 39.397 227.269 33.4395 227.269 33.4395C227.269 33.4395 264.513 85.5677 254.085 91.5252C243.657 97.4827 229.256 94.504 229.256 94.504L224.183 49.9726C223.56 47.6186 220.32 47.3637 219.336 49.5913L205.419 81.0995Z"
            fill="#CA373C"
          />
          <path
            d="M219.307 31.6119C227.279 31.6119 233.742 25.1509 233.742 17.1809C233.742 9.21095 227.279 2.75 219.307 2.75C211.335 2.75 204.873 9.21095 204.873 17.1809C204.873 25.1509 211.335 31.6119 219.307 31.6119Z"
            fill="#FFB6B6"
          />
          <path
            d="M230.738 28.0909C229.436 28.5769 227.44 29.3326 226.138 29.8187C224.923 27.3985 226.411 26.1427 226.566 23.4395C226.617 22.5374 226.747 21.6343 226.672 20.7338C226.598 19.8334 226.288 18.909 225.609 18.3132C224.569 17.4017 222.838 17.55 221.832 18.4979C220.826 19.4458 220.539 21.0122 220.951 22.3319C216.993 20.6214 214.436 16.1341 214.982 11.8582C213.8 11.3949 212.589 10.9255 211.32 10.89C210.051 10.8546 208.691 11.3387 208.015 12.4129C207.541 13.1661 207.446 14.1223 206.914 14.8357C206.049 15.995 204.18 16.0848 203.032 15.2055C201.884 14.3261 201.444 12.728 201.689 11.3028C201.934 9.87757 200.152 6.96906 201.15 5.92183C201.83 5.20743 205.208 6.21968 205.967 5.58948C206.659 5.01453 207.355 4.43767 208.118 3.96069C209.087 3.35524 210.16 2.91678 211.276 2.67041C212.332 2.43736 213.416 2.37615 214.496 2.31568C215.591 2.25429 217.107 0.0731585 218.203 0.0117658C221.429 -0.168977 224.312 1.77848 227.407 2.70564C230.502 3.63281 232.449 6.29529 234.162 9.03402C236.602 12.9351 235.773 17.2095 234.092 20.9397C233.677 21.8618 235.071 22.8307 234.864 23.8206C234.673 24.7408 233.81 25.4073 233.609 26.3254C233.436 27.1105 232.417 26.2009 232.174 26.9671C231.964 27.6282 231.346 28.0949 230.685 28.3059C230.024 28.517 229.317 28.5127 228.623 28.5064"
            fill="black"
          />
          <path
            d="M227.64 33.0703L228.148 33.4406L229.431 34.3742C233.287 37.1809 232.929 43.0398 228.759 45.3557L223.545 37.0292"
            fill="#CA373C"
          />
          <path
            d="M154.843 50.2438C156.145 51.1026 157.145 52.1841 157.753 53.2875L170.67 60.6858L166.969 66.7279L154.264 58.5726C153.01 58.4476 151.622 57.9539 150.321 57.0951C147.347 55.1331 145.948 52.009 147.197 50.117C148.446 48.2251 151.869 48.2818 154.843 50.2438Z"
            fill="#FFB6B6"
          />
          <path
            d="M215.62 42.4458C223.857 37.3952 232.135 48.9615 224.811 55.2633L224.786 55.2847L195.521 82.8029L160.497 65.512L163.96 56.1762L191.095 66.9224L211.45 45.7967C212.867 44.3784 214.261 43.2792 215.62 42.4458Z"
            fill="#2F3A79"
          />
        </g>
        <path
          d="M42.1282 88.3926C41.4478 88.3926 40.8945 88.9457 40.8945 89.626V108.744C40.8945 109.424 41.4478 109.977 42.1282 109.977C42.8087 109.977 43.362 109.424 43.362 108.744V89.626C43.362 88.9457 42.8087 88.3926 42.1282 88.3926Z"
          fill="black"
        />
        <path
          d="M54.2193 106.814C58.4653 106.814 61.9074 103.445 61.9074 99.2898C61.9074 95.1343 58.4653 91.7656 54.2193 91.7656C49.9733 91.7656 46.5312 95.1343 46.5312 99.2898C46.5312 103.445 49.9733 106.814 54.2193 106.814Z"
          fill="url(#paint0_radial_3694_8732)"
        />
        <path
          d="M115.851 96.7165H74.4693C73.0496 96.7165 71.8945 95.5617 71.8945 94.1424C71.8945 92.7231 73.0496 91.5684 74.4693 91.5684H115.851C117.271 91.5684 118.426 92.7231 118.426 94.1424C118.426 95.5617 117.271 96.7165 115.851 96.7165Z"
          fill="white"
        />
        <path
          d="M148.146 105.429H74.4693C73.0496 105.429 71.8945 104.275 71.8945 102.855C71.8945 101.436 73.0496 100.281 74.4693 100.281H148.146C149.565 100.281 150.72 101.436 150.72 102.855C150.72 104.275 149.565 105.429 148.146 105.429Z"
          fill="white"
        />
        <path
          d="M7.68808 147.503C11.9341 147.503 15.3762 144.135 15.3762 139.979C15.3762 135.824 11.9341 132.455 7.68808 132.455C3.44207 132.455 0 135.824 0 139.979C0 144.135 3.44207 147.503 7.68808 147.503Z"
          fill="url(#paint1_radial_3694_8732)"
        />
        <path
          d="M69.3199 137.406H27.938C26.5183 137.406 25.3633 136.251 25.3633 134.832C25.3633 133.413 26.5183 132.258 27.938 132.258H69.3199C70.7396 132.258 71.8946 133.413 71.8946 134.832C71.8946 136.251 70.7396 137.406 69.3199 137.406Z"
          fill="white"
        />
        <path
          d="M79.8961 172.179C84.1421 172.179 87.5842 168.811 87.5842 164.655C87.5842 160.5 84.1421 157.131 79.8961 157.131C75.6501 157.131 72.208 160.5 72.208 164.655C72.208 168.811 75.6501 172.179 79.8961 172.179Z"
          fill="url(#paint2_radial_3694_8732)"
        />
        <path
          d="M173.823 170.793H100.146C98.7268 170.793 97.5718 169.638 97.5718 168.219C97.5718 166.799 98.7268 165.645 100.146 165.645H173.823C175.243 165.645 176.398 166.799 176.398 168.219C176.398 169.638 175.243 170.793 173.823 170.793Z"
          fill="white"
        />
        <path
          d="M155.621 31.4898C159.867 31.4898 163.309 28.1211 163.309 23.9656C163.309 19.8101 159.867 16.4414 155.621 16.4414C151.375 16.4414 147.933 19.8101 147.933 23.9656C147.933 28.1211 151.375 31.4898 155.621 31.4898Z"
          fill="url(#paint3_radial_3694_8732)"
        />
        <path
          d="M297.135 157.628C301.381 157.628 304.823 154.26 304.823 150.104C304.823 145.949 301.381 142.58 297.135 142.58C292.889 142.58 289.447 145.949 289.447 150.104C289.447 154.26 292.889 157.628 297.135 157.628Z"
          fill="url(#paint4_radial_3694_8732)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3694_8732"
          x="112.303"
          y="3.50586"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter1_d_3694_8732"
          x="123.406"
          y="8.43945"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter2_d_3694_8732"
          x="244.927"
          y="123.146"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter3_d_3694_8732"
          x="136.74"
          y="-6"
          width="179.114"
          height="306.086"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <radialGradient
          id="paint0_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.2193 99.2898) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.68808 139.979) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(79.8961 164.655) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(155.621 23.9656) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(297.135 150.104) rotate(90) scale(7.52419 7.68807)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <clipPath id="clip0_3694_8732">
          <rect width="345" height="287" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ArrowIcon = () => (
  <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.70898 7.89683C9.70898 8.20152 9.58594 8.47691 9.33984 8.723L2.51074 15.4027C2.41113 15.5023 2.2998 15.5785 2.17676 15.6312C2.05371 15.6781 1.92188 15.7015 1.78125 15.7015C1.58203 15.7015 1.40332 15.6546 1.24512 15.5609C1.08105 15.4671 0.952149 15.3441 0.858399 15.1918C0.764649 15.0335 0.717774 14.8548 0.717774 14.6556C0.717773 14.3685 0.826172 14.1166 1.04297 13.8998L7.63477 7.47495V8.3187L1.04297 1.90269C0.826171 1.68589 0.717773 1.43394 0.717773 1.14683C0.717773 0.95347 0.764648 0.777689 0.858398 0.619486C0.952148 0.461283 1.08105 0.335306 1.24512 0.241556C1.40332 0.147806 1.58203 0.100931 1.78125 0.100931C2.0625 0.100931 2.30273 0.20347 2.50195 0.408548L9.33984 7.07945C9.46289 7.19663 9.55664 7.32554 9.62109 7.46616C9.67969 7.60093 9.70898 7.74449 9.70898 7.89683Z"
      fill="black"
      fillOpacity="0.5"
    />
  </svg>
);

export const SearchFilterIconMob = () => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 3.4375H6.44444M6.44444 3.4375C6.44444 4.78625 7.489 5.875 8.77778 5.875H9.55556C10.8443 5.875 11.8889 4.78625 11.8889 3.4375C11.8889 2.08875 10.8443 1 9.55556 1H8.77778C7.489 1 6.44444 2.08875 6.44444 3.4375ZM11.1111 11.5625H15M14.2222 3.4375H15M1 11.5625H3.33333M3.33333 11.5625C3.33333 12.9112 4.37789 14 5.66667 14H6.44444C7.73322 14 8.77778 12.9112 8.77778 11.5625C8.77778 10.2138 7.73322 9.125 6.44444 9.125H5.66667C4.37789 9.125 3.33333 10.2138 3.33333 11.5625Z"
        stroke="#363636"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const BackIcon = () => {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.35833 1C4.60935 2.29326 3.03515 3.80752 1.675 5.505C1.56182 5.64516 1.50006 5.81985 1.5 6M1.5 6C1.50006 6.18015 1.56182 6.35484 1.675 6.49499C3.03515 8.19248 4.60935 9.70674 6.35833 11M1.5 6H16.5"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
  );
};

export const UpcomingIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke-linecap="round"
      stroke-linejoin="round"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m14 18 4-4 4 4"></path>
      <path d="M16 2v4"></path>
      <path d="M18 22v-8"></path>
      <path d="M21 11.343V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9"></path>
      <path d="M3 10h18"></path>
      <path d="M8 2v4"></path>
    </svg>
  );
};

export const PendingIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 256 256"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M244,56v48a12,12,0,0,1-12,12H184a12,12,0,1,1,0-24H201.1l-19-17.38c-.13-.12-.26-.24-.38-.37A76,76,0,1,0,127,204h1a75.53,75.53,0,0,0,52.15-20.72,12,12,0,0,1,16.49,17.45A99.45,99.45,0,0,1,128,228h-1.37A100,100,0,1,1,198.51,57.06L220,76.72V56a12,12,0,0,1,24,0Z"></path>
    </svg>
  );
};

export const OnGoingIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 256 256"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M224,48V96a8,8,0,0,1-8,8H168a8,8,0,0,1-5.66-13.66L180.65,72a79.48,79.48,0,0,0-54.72-22.09h-.45A79.52,79.52,0,0,0,69.59,72.71,8,8,0,0,1,58.41,61.27,96,96,0,0,1,192,60.7l18.36-18.36A8,8,0,0,1,224,48ZM186.41,183.29A80,80,0,0,1,75.35,184l18.31-18.31A8,8,0,0,0,88,152H40a8,8,0,0,0-8,8v48a8,8,0,0,0,13.66,5.66L64,195.3a95.42,95.42,0,0,0,66,26.76h.53a95.36,95.36,0,0,0,67.07-27.33,8,8,0,0,0-11.18-11.44Z"></path>
    </svg>
  );
};

export const CircleLoading = () => {
  return (
    <svg viewBox="25 25 50 50">
      <circle r="20" cy="50" cx="50">
        {""}
      </circle>
    </svg>
  );
};

export const ArrowDownIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 24 24"
      height="25px"
      width="25px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="none" d="M0 0h24v24H0V0z"></path>
      <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
    </svg>
  );
};

export const LibraryIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      version="1.1"
      viewBox="0 0 17 16"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16 15v-1h-1v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-1v1h-1v1h17v-1h-1z"></path>
      <path d="M8 0h1l8 5v1h-17v-1l8-5z"></path>
    </svg>
  );
};

export const FilesIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 512 512"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"></path>
    </svg>
  );
};
export const FaqIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 16 16"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"></path>
      <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"></path>
    </svg>
  );
};

export const GradientCircle = () => {
  return (
    <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_2236_6832" fill="white">
        <path d="M90 45C90 69.8528 69.8528 90 45 90C20.1472 90 0 69.8528 0 45C0 20.1472 20.1472 0 45 0C69.8528 0 90 20.1472 90 45Z" />
      </mask>
      <path
        d="M88 45C88 68.7482 68.7482 88 45 88V92C70.9574 92 92 70.9574 92 45H88ZM45 88C21.2518 88 2 68.7482 2 45H-2C-2 70.9574 19.0426 92 45 92V88ZM2 45C2 21.2518 21.2518 2 45 2V-2C19.0426 -2 -2 19.0426 -2 45H2ZM45 2C68.7482 2 88 21.2518 88 45H92C92 19.0426 70.9574 -2 45 -2V2Z"
        fill="url(#paint0_linear_2236_6832)"
        fill-opacity="0.1"
        mask="url(#path-1-inside-1_2236_6832)"
      />
      <defs>
        <linearGradient id="paint0_linear_2236_6832" x1="45" y1="0" x2="45" y2="90" gradientUnits="userSpaceOnUse">
          <stop stop-color="#CA373C" />
          <stop offset="1" stop-color="#2F3A79" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const GradientCutCircle = () => {
  return (
    <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_1963_7993" fill="white">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M84.5253 66.5295C88.016 60.1345 90 52.799 90 45C90 20.1472 69.8528 0 45 0C20.1472 0 0 20.1472 0 45C0 69.8528 20.1472 90 45 90C50.5373 90 55.8411 88.9998 60.7405 87.1703C59.3174 84.7789 58.5 81.9849 58.5 79C58.5 70.1634 65.6634 63 74.5 63C78.2954 63 81.7822 64.3215 84.5253 66.5295Z"
        />
      </mask>
      <path
        d="M84.5253 66.5295L82.6441 68.8665L85.4393 71.1164L87.1585 67.9669L84.5253 66.5295ZM60.7405 87.1703L61.7899 89.9808L65.1559 88.7239L63.3185 85.6362L60.7405 87.1703ZM87 45C87 52.2842 85.1482 59.1269 81.892 65.0922L87.1585 67.9669C90.8839 61.1421 93 53.3137 93 45H87ZM45 3C68.196 3 87 21.804 87 45H93C93 18.4903 71.5097 -3 45 -3V3ZM3 45C3 21.804 21.804 3 45 3V-3C18.4903 -3 -3 18.4903 -3 45H3ZM45 87C21.804 87 3 68.196 3 45H-3C-3 71.5097 18.4903 93 45 93V87ZM59.691 84.3599C55.1222 86.0659 50.1736 87 45 87V93C50.9011 93 56.5599 91.9338 61.7899 89.9808L59.691 84.3599ZM63.3185 85.6362C62.1639 83.696 61.5 81.4301 61.5 79H55.5C55.5 82.5397 56.4708 85.8618 58.1624 88.7045L63.3185 85.6362ZM61.5 79C61.5 71.8203 67.3203 66 74.5 66V60C64.0066 60 55.5 68.5066 55.5 79H61.5ZM74.5 66C77.5867 66 80.4148 67.072 82.6441 68.8665L86.4064 64.1926C83.1496 61.5711 79.0042 60 74.5 60V66Z"
        fill="white"
        mask="url(#path-1-inside-1_1963_7993)"
      />
      <path
        d="M84.5253 66.5295L82.6441 68.8665L85.4393 71.1164L87.1585 67.9669L84.5253 66.5295ZM60.7405 87.1703L61.7899 89.9808L65.1559 88.7239L63.3185 85.6362L60.7405 87.1703ZM87 45C87 52.2842 85.1482 59.1269 81.892 65.0922L87.1585 67.9669C90.8839 61.1421 93 53.3137 93 45H87ZM45 3C68.196 3 87 21.804 87 45H93C93 18.4903 71.5097 -3 45 -3V3ZM3 45C3 21.804 21.804 3 45 3V-3C18.4903 -3 -3 18.4903 -3 45H3ZM45 87C21.804 87 3 68.196 3 45H-3C-3 71.5097 18.4903 93 45 93V87ZM59.691 84.3599C55.1222 86.0659 50.1736 87 45 87V93C50.9011 93 56.5599 91.9338 61.7899 89.9808L59.691 84.3599ZM63.3185 85.6362C62.1639 83.696 61.5 81.4301 61.5 79H55.5C55.5 82.5397 56.4708 85.8618 58.1624 88.7045L63.3185 85.6362ZM61.5 79C61.5 71.8203 67.3203 66 74.5 66V60C64.0066 60 55.5 68.5066 55.5 79H61.5ZM74.5 66C77.5867 66 80.4148 67.072 82.6441 68.8665L86.4064 64.1926C83.1496 61.5711 79.0042 60 74.5 60V66Z"
        fill="url(#paint0_linear_1963_7993)"
        fill-opacity="0.1"
        mask="url(#path-1-inside-1_1963_7993)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M84.5252 66.5295C79.3705 75.9729 70.9301 83.3653 60.7405 87.1703C59.3174 84.7789 58.5 81.9849 58.5 79C58.5 70.1634 65.6634 63 74.5 63C78.2954 63 81.7822 64.3215 84.5252 66.5295Z"
        fill="#FFF"
      />
      <defs>
        <linearGradient id="paint0_linear_1963_7993" x1="45" y1="0" x2="45" y2="90" gradientUnits="userSpaceOnUse">
          <stop stop-color="#CA373C" />
          <stop offset="1" stop-color="#2F3A79" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const VerticalIcon = () => {
  return (
    <svg width="5" height="22" viewBox="0 0 5 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.25 3.5C1.56 3.5 1 2.9375 1 2.25C1 1.5625 1.56 1 2.25 1C2.94 1 3.5 1.5625 3.5 2.25C3.5 2.9375 2.94 3.5 2.25 3.5ZM2.25 12.25C1.56 12.25 1 11.6875 1 11C1 10.3125 1.56 9.75 2.25 9.75C2.94 9.75 3.5 10.3125 3.5 11C3.5 11.6875 2.94 12.25 2.25 12.25ZM2.25 21C1.56 21 1 20.4375 1 19.75C1 19.0625 1.56 18.5 2.25 18.5C2.94 18.5 3.5 19.0625 3.5 19.75C3.5 20.4375 2.94 21 2.25 21Z"
        stroke="#2F3A79"
        stroke-opacity="0.5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const InfoIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.38916 13.8916C6.50472 13.8916 5.67106 13.7223 4.88818 13.3838C4.10954 13.0452 3.42188 12.5776 2.8252 11.981C2.22852 11.3843 1.7609 10.6966 1.42236 9.91797C1.08382 9.13509 0.914551 8.30143 0.914551 7.41699C0.914551 6.53255 1.08382 5.70101 1.42236 4.92236C1.7609 4.13949 2.2264 3.44971 2.81885 2.85303C3.41553 2.25635 4.10319 1.78874 4.88184 1.4502C5.66471 1.11165 6.49837 0.942383 7.38281 0.942383C8.26725 0.942383 9.10091 1.11165 9.88379 1.4502C10.6667 1.78874 11.3564 2.25635 11.9531 2.85303C12.5498 3.44971 13.0174 4.13949 13.356 4.92236C13.6945 5.70101 13.8638 6.53255 13.8638 7.41699C13.8638 8.30143 13.6945 9.13509 13.356 9.91797C13.0174 10.6966 12.5498 11.3843 11.9531 11.981C11.3564 12.5776 10.6667 13.0452 9.88379 13.3838C9.10514 13.7223 8.2736 13.8916 7.38916 13.8916ZM7.38916 12.8125C8.13818 12.8125 8.83854 12.6729 9.49023 12.3936C10.1462 12.1143 10.7196 11.7292 11.2104 11.2383C11.7056 10.7432 12.0907 10.1698 12.3657 9.51807C12.645 8.86637 12.7847 8.16602 12.7847 7.41699C12.7847 6.66797 12.645 5.96761 12.3657 5.31592C12.0864 4.66423 11.6992 4.09082 11.2041 3.5957C10.709 3.10059 10.1356 2.71549 9.48389 2.44043C8.83219 2.16113 8.13184 2.02148 7.38281 2.02148C6.63379 2.02148 5.93343 2.16113 5.28174 2.44043C4.63005 2.71549 4.05876 3.10059 3.56787 3.5957C3.07699 4.09082 2.69189 4.66423 2.4126 5.31592C2.13753 5.96761 2 6.66797 2 7.41699C2 8.16602 2.13753 8.86637 2.4126 9.51807C2.69189 10.1698 3.07699 10.7432 3.56787 11.2383C4.06299 11.7292 4.63639 12.1143 5.28809 12.3936C5.93978 12.6729 6.64014 12.8125 7.38916 12.8125ZM6.27832 10.9082C6.14714 10.9082 6.03711 10.8659 5.94824 10.7812C5.85938 10.6966 5.81494 10.5908 5.81494 10.4639C5.81494 10.3369 5.85938 10.2311 5.94824 10.1465C6.03711 10.0618 6.14714 10.0195 6.27832 10.0195H7.06543V7.10596H6.38623C6.25505 7.10596 6.14502 7.06364 6.05615 6.979C5.96729 6.89437 5.92285 6.78857 5.92285 6.66162C5.92285 6.53467 5.96729 6.42887 6.05615 6.34424C6.14502 6.2596 6.25505 6.21729 6.38623 6.21729H7.57959C7.7404 6.21729 7.86312 6.27018 7.94775 6.37598C8.03239 6.47754 8.07471 6.61507 8.07471 6.78857V10.0195H8.86182C8.993 10.0195 9.10303 10.0618 9.19189 10.1465C9.28076 10.2311 9.3252 10.3369 9.3252 10.4639C9.3252 10.5908 9.28076 10.6966 9.19189 10.7812C9.10303 10.8659 8.993 10.9082 8.86182 10.9082H6.27832ZM7.33203 5.15723C7.10352 5.15723 6.90885 5.07682 6.74805 4.91602C6.58724 4.75521 6.50684 4.56055 6.50684 4.33203C6.50684 4.09928 6.58724 3.90251 6.74805 3.7417C6.90885 3.58089 7.10352 3.50049 7.33203 3.50049C7.56478 3.50049 7.75944 3.58089 7.91602 3.7417C8.07682 3.90251 8.15723 4.09928 8.15723 4.33203C8.15723 4.56055 8.07682 4.75521 7.91602 4.91602C7.75944 5.07682 7.56478 5.15723 7.33203 5.15723Z"
      fill="black"
      fill-opacity="0.5"
    />
  </svg>
);

export const HistoryIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 24 24"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="m22.69 18.37 1.14-1-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L20 14h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49c.32.27.68.48 1.08.63L18 24h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27zM19 21c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM11 7v5.41l2.36 2.36 1.04-1.79-1.4-1.39V7h-2zm10 5a9 9 0 0 0-9-9C9.17 3 6.65 4.32 5 6.36V4H3v6h6V8H6.26A7.01 7.01 0 0 1 12 5c3.86 0 7 3.14 7 7h2zm-10.14 6.91c-2.99-.49-5.35-2.9-5.78-5.91H3.06c.5 4.5 4.31 8 8.94 8h.07l-1.21-2.09z"></path>
    </svg>
  );
};
export const OrganizationIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 16 16"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.111 4.663A2 2 0 1 1 6.89 1.337a2 2 0 0 1 2.222 3.326zm-.555-2.494A1 1 0 1 0 7.444 3.83a1 1 0 0 0 1.112-1.66zm2.61.03a1.494 1.494 0 0 1 1.895.188 1.513 1.513 0 0 1-.487 2.46 1.492 1.492 0 0 1-1.635-.326 1.512 1.512 0 0 1 .228-2.321zm.48 1.61a.499.499 0 1 0 .705-.708.509.509 0 0 0-.351-.15.499.499 0 0 0-.5.503.51.51 0 0 0 .146.356zM3.19 12.487H5v1.005H3.19a1.197 1.197 0 0 1-.842-.357 1.21 1.21 0 0 1-.348-.85v-1.81a.997.997 0 0 1-.71-.332A1.007 1.007 0 0 1 1 9.408V7.226c.003-.472.19-.923.52-1.258.329-.331.774-.52 1.24-.523H4.6a2.912 2.912 0 0 0-.55 1.006H2.76a.798.798 0 0 0-.54.232.777.777 0 0 0-.22.543v2.232h1v2.826a.202.202 0 0 0 .05.151.24.24 0 0 0 .14.05zm7.3-6.518a1.765 1.765 0 0 0-1.25-.523H6.76a1.765 1.765 0 0 0-1.24.523c-.33.335-.517.786-.52 1.258v3.178a1.06 1.06 0 0 0 .29.734 1 1 0 0 0 .71.332v2.323a1.202 1.202 0 0 0 .35.855c.18.168.407.277.65.312h2a1.15 1.15 0 0 0 1-1.167V11.47a.997.997 0 0 0 .71-.332 1.006 1.006 0 0 0 .29-.734V7.226a1.8 1.8 0 0 0-.51-1.258zM10 10.454H9v3.34a.202.202 0 0 1-.06.14.17.17 0 0 1-.14.06H7.19a.21.21 0 0 1-.2-.2v-3.34H6V7.226c0-.203.079-.398.22-.543a.798.798 0 0 1 .54-.232h2.48a.778.778 0 0 1 .705.48.748.748 0 0 1 .055.295v3.228zm2.81 3.037H11v-1.005h1.8a.24.24 0 0 0 .14-.05.2.2 0 0 0 .06-.152V9.458h1V7.226a.777.777 0 0 0-.22-.543.798.798 0 0 0-.54-.232h-1.29a2.91 2.91 0 0 0-.55-1.006h1.84a1.77 1.77 0 0 1 1.24.523c.33.335.517.786.52 1.258v2.182c0 .273-.103.535-.289.733-.186.199-.44.318-.711.333v1.81c0 .319-.125.624-.348.85a1.197 1.197 0 0 1-.842.357zM4 1.945a1.494 1.494 0 0 0-1.386.932A1.517 1.517 0 0 0 2.94 4.52 1.497 1.497 0 0 0 5.5 3.454c0-.4-.158-.784-.44-1.067A1.496 1.496 0 0 0 4 1.945zm0 2.012a.499.499 0 0 1-.5-.503.504.504 0 0 1 .5-.503.509.509 0 0 1 .5.503.504.504 0 0 1-.5.503z"
      ></path>
    </svg>
  );
};
export const PdfIcon = () => {
  return (
    <svg width="30" height="32" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5556 2H15C18.0647 2 21.0039 3.24227 23.171 5.45323C25.3381 7.66418 26.5556 10.6627 26.5556 13.7895V15.2632C26.5556 12.8168 24.6157 10.8421 22.2222 10.8421H21.3555C20.8182 10.8421 20.551 10.8421 20.3257 10.8126C19.7223 10.713 19.1653 10.4213 18.7341 9.97934C18.303 9.53734 18.0198 8.9677 17.925 8.35167C17.8889 8.13061 17.8889 7.85067 17.8889 7.30541V6.42105C17.8889 3.97474 15.949 2 13.5556 2ZM13.5556 2H9.22222C7.68986 2 6.22026 2.62078 5.13671 3.72625C4.05317 4.83173 3.44444 6.33136 3.44444 7.89474V15.2632M2 30V19.6842H4.16667C5.12439 19.6842 6.04288 20.0726 6.7201 20.7636C7.39731 21.4545 7.77778 22.3913 7.77778 23.3684C7.77778 24.3455 7.39731 25.2823 6.7201 25.9733C6.04288 26.6642 5.12439 27.0526 4.16667 27.0526H2M22.2222 30V19.6842H28M28 25.5789H22.2222M12.1111 19.6842V30H12.8333C15.6254 30 17.8889 27.6863 17.8889 24.8421C17.8889 21.9979 15.6254 19.6842 12.8333 19.6842H12.1111Z"
        stroke="#2F3A79"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ExcelIcon = () => {
  return (
    <svg width="27" height="32" viewBox="0 0 27 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.04 2.08118V3.68002C16.04 6.03202 16.04 7.208 16.5305 8.1068C16.9627 8.89653 17.6509 9.53879 18.497 9.94216C19.46 10.4 20.72 10.4 23.24 10.4H24.953M16.04 2.08118C15.449 1.99998 14.744 2 13.5635 2H10.64C7.28003 2 5.60005 1.99996 4.31605 2.61036C3.18657 3.14654 2.26852 4.00345 1.69405 5.05763C1.04005 6.25603 1.04004 7.82403 1.04004 10.96V21.04C1.04004 24.176 1.04005 25.744 1.69405 26.9424C2.26852 27.9965 3.18657 28.8535 4.31605 29.3896C5.60005 30 7.28003 30 10.64 30H15.44C18.8 30 20.48 30 21.764 29.3896C22.8935 28.8535 23.8116 27.9965 24.386 26.9424C25.04 25.744 25.04 24.176 25.04 21.04V12.7114C25.04 11.6096 25.04 10.9516 24.953 10.4M16.04 2.08118C16.184 2.10078 16.3205 2.12463 16.4555 2.15543C17.0675 2.29263 17.6525 2.51798 18.1895 2.82458C18.7955 3.17178 19.3145 3.6562 20.3525 4.625L22.2275 6.375C23.2655 7.3438 23.7845 7.82822 24.1565 8.39382C24.485 8.89502 24.7266 9.44103 24.8736 10.0122C24.9066 10.1382 24.932 10.2656 24.953 10.4M7.04004 17.4H19.04M7.04004 23H14.54M9.44004 13.6667V25.3333M15.44 13.6667V25.3333"
        stroke="#2F3A79"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DocumentIcon = () => {
  return (
    <svg width="26" height="32" viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.905 2.08118V3.68002C15.905 6.03202 15.905 7.208 16.3751 8.1068C16.7893 8.89653 17.4488 9.5388 18.2597 9.94216C19.1825 10.4 20.39 10.4 22.805 10.4H24.4467M15.905 2.08118C15.3387 1.99998 14.663 2 13.5317 2H10.73C7.51002 2 5.90004 1.99996 4.66954 2.61036C3.58712 3.14654 2.70732 4.00345 2.15679 5.05763C1.53004 6.25603 1.53003 7.82403 1.53003 10.96V21.04C1.53003 24.176 1.53004 25.744 2.15679 26.9424C2.70732 27.9965 3.58712 28.8535 4.66954 29.3896C5.90004 30 7.51002 30 10.73 30H15.33C18.55 30 20.16 30 21.3905 29.3896C22.4729 28.8535 23.3527 27.9965 23.9033 26.9424C24.53 25.744 24.53 24.176 24.53 21.04V12.7114C24.53 11.6096 24.53 10.9516 24.4467 10.4M15.905 2.08118C16.043 2.10078 16.1738 2.12463 16.3032 2.15543C16.8897 2.29263 17.4503 2.51798 17.965 2.82458C18.5457 3.17178 19.0431 3.6562 20.0378 4.625L21.8347 6.375C22.8295 7.3438 23.3268 7.82822 23.6833 8.39382C23.9981 8.89502 24.2296 9.44103 24.3705 10.0122C24.4021 10.1382 24.4265 10.2656 24.4467 10.4M7.28003 17.4H18.78M7.28003 23H14.4675"
        stroke="#2F3A79"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ImageIcon = () => {
  return (
    <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.01 11.5972C28.883 11.3472 27.7112 11.2222 26.51 11.2222C17.858 11.2222 10.7992 17.9861 10.4254 26.4861M30.01 11.5972V15.3889C30.01 19.2778 30.01 21.2222 29.247 22.7084C28.5759 24.0167 27.5053 25.0812 26.188 25.7499C24.69 26.4999 22.73 26.5 18.81 26.5H13.21C12.1474 26.5 11.2304 26.5 10.4254 26.4861M30.01 11.5972C30.0044 8.37503 29.9414 6.63886 29.247 5.29164C28.5759 3.98328 27.5053 2.91881 26.188 2.25005C24.69 1.50005 22.73 1.5 18.81 1.5H13.21C9.29001 1.5 7.33 1.50005 5.832 2.25005C4.51472 2.91881 3.4441 3.98328 2.77301 5.29164C2.01001 6.77775 2.01001 8.72222 2.01001 12.6111V15.3889C2.01001 19.2778 2.01001 21.2222 2.77301 22.7084C3.4441 24.0167 4.51472 25.0812 5.832 25.7499C6.924 26.2916 8.26101 26.4444 10.4254 26.4861M9.71001 11.2222C9.42977 11.2295 9.15089 11.181 8.88983 11.0796C8.62876 10.9783 8.39081 10.8261 8.18997 10.632C7.98914 10.438 7.82949 10.2062 7.72045 9.94998C7.61142 9.69376 7.55518 9.41836 7.55509 9.14024C7.55499 8.86213 7.61103 8.5868 7.7199 8.33051C7.82876 8.07422 7.98826 7.84227 8.18897 7.6481C8.38968 7.45394 8.62753 7.30153 8.88852 7.20001C9.14952 7.09848 9.42835 7.04982 9.7086 7.05691C10.256 7.07075 10.7763 7.29615 11.1586 7.68507C11.5409 8.07398 11.7549 8.59567 11.7551 9.13889C11.7553 9.68211 11.5416 10.2039 11.1595 10.5931C10.7775 10.9822 10.2574 11.208 9.71001 11.2222Z"
        stroke="#2F3A79"
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const VideosIcon = () => {
  return (
    <svg width="31" height="22" viewBox="0 0 31 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.0214 13.7572C22.048 14.5715 22.4092 15.3286 23.0196 15.8572L24.4196 17.0571C26.241 18.6143 29.02 17.2999 29.02 14.8714V7.12863C29.02 4.70006 26.241 3.38573 24.4196 4.94287L23.0196 6.14282C22.412 6.65711 22.0508 7.41437 22.0214 8.22866M22.0214 13.7572L22.02 15.2857C22.02 16.8012 21.43 18.2546 20.3798 19.3262C19.3296 20.3979 17.9052 21 16.42 21H6.62002C5.13481 21 3.71042 20.3979 2.66022 19.3262C1.61001 18.2546 1.02002 16.8012 1.02002 15.2857V6.71429C1.02002 5.19876 1.61001 3.74539 2.66022 2.67376C3.71042 1.60212 5.13481 1 6.62002 1H16.42C17.9052 1 19.3296 1.60212 20.3798 2.67376C21.43 3.74539 22.02 5.19876 22.02 6.71429L22.0214 8.22866M22.0214 13.7572V8.22866"
        stroke="#2F3A79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CancelIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 512 512"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34z"></path>
    </svg>
  );
};
export const ThreeDotIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 16 16"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"></path>
    </svg>
  );
};

export const ShareIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      fill="#2f3a79"
      class="bi bi-share-fill"
      viewBox="0 0 16 16"
    >
      <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5"></path>
    </svg>
  );
};
export const SaveIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 448 512"
      height="20px"
      width="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"></path>
    </svg>
  );
};
export const ShrinkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-arrows-angle-contract"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M.172 15.828a.5.5 0 0 0 .707 0l4.096-4.096V14.5a.5.5 0 1 0 1 0v-3.975a.5.5 0 0 0-.5-.5H1.5a.5.5 0 0 0 0 1h2.768L.172 15.121a.5.5 0 0 0 0 .707M15.828.172a.5.5 0 0 0-.707 0l-4.096 4.096V1.5a.5.5 0 1 0-1 0v3.975a.5.5 0 0 0 .5.5H14.5a.5.5 0 0 0 0-1h-2.768L15.828.879a.5.5 0 0 0 0-.707"
      ></path>
    </svg>
  );
};

